// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-pagination-con[data-v-4117ef0c]{text-align:center}.my-pagination[data-v-4117ef0c] .el-pagination.is-background .btn-next,.my-pagination[data-v-4117ef0c] .el-pagination.is-background .btn-prev,.my-pagination[data-v-4117ef0c] .el-pagination.is-background .el-pager li{border:1px solid #e3e4e9;background:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
